import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'internal-login',
  templateUrl: './internal-login.page.html',
  styleUrls: ['./internal-login.page.scss'],
})
export class InternalLoginPage {
  readonly identifierFormControl = new FormControl('');
  readonly passwordFormControl = new FormControl('');

  constructor(private authService: AuthService) {}

  login() {
    if (this.identifierFormControl.value === '' && this.passwordFormControl.value === '') {
      return;
    }

    this.authService
      .login(this.identifierFormControl.value, this.passwordFormControl.value)
      .subscribe(() => (window.location.href = '/'));
  }
}
